import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const HowItWorksSection = () => {
  const steps = [
    {
      id: 1,
      title: "سوال خود را بپرسید",
      description: "سوال حقوقی خود را به صورت واضح و مفصل در چت‌بات وارد کنید",
      icon: "Edit3",
      color: "bg-primary"
    },
    {
      id: 2,
      title: "تحلیل هوشمند",
      description: "هوش مصنوعی سوال شما را تحلیل کرده و بهترین پاسخ را آماده می‌کند",
      icon: "Brain",
      color: "bg-secondary"
    },
    {
      id: 3,
      title: "دریافت پاسخ",
      description: "پاسخ جامع و تخصصی همراه با منابع قانونی مرتبط دریافت کنید",
      icon: "CheckCircle",
      color: "bg-success"
    },
    {
      id: 4,
      title: "ارجاع به متخصص",
      description: "در صورت نیاز، با وکلای متخصص ارتباط برقرار کرده و مشاوره حضوری دریافت کنید",
      icon: "UserCheck",
      color: "bg-accent"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            چگونه کار می‌کند؟
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            در چهار مرحله ساده به مشاوره حقوقی تخصصی دسترسی پیدا کنید
          </p>
        </motion.div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Lines - Hidden on mobile */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-primary via-secondary via-success to-accent opacity-20 transform -translate-y-1/2"></div>

          {/* Steps Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
            {steps?.map((step, index) => (
              <motion.div
                key={step?.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="text-center group"
              >
                {/* Step Number and Icon */}
                <div className="relative mb-6">
                  {/* Step Number Background */}
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-background border-2 border-border rounded-full flex items-center justify-center z-20">
                    <span className="text-sm font-bold text-foreground">
                      {step?.id?.toString()?.replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'?.[d])}
                    </span>
                  </div>

                  {/* Icon Container */}
                  <div className={`relative w-20 h-20 ${step?.color} rounded-2xl flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300 shadow-moderate`}>
                    <Icon name={step?.icon} size={36} color="white" />
                    
                    {/* Glow Effect */}
                    <div className={`absolute inset-0 ${step?.color} rounded-2xl opacity-0 group-hover:opacity-20 blur-lg transition-opacity duration-300`}></div>
                  </div>
                </div>

                {/* Step Content */}
                <div className="space-y-4">
                  <h3 className="text-xl font-bold text-foreground group-hover:text-primary transition-colors duration-300">
                    {step?.title}
                  </h3>
                  
                  <p className="text-muted-foreground leading-relaxed">
                    {step?.description}
                  </p>
                </div>

                {/* Mobile Connection Line */}
                {index < steps?.length - 1 && (
                  <div className="lg:hidden flex justify-center mt-8 mb-8">
                    <div className="w-0.5 h-8 bg-gradient-to-b from-primary to-secondary opacity-30"></div>
                  </div>
                )}
              </motion.div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          viewport={{ once: true }}
          className="text-center mt-16"
        >
          <div className="bg-gradient-to-r from-primary/10 to-secondary/10 rounded-2xl p-8 border border-primary/20">
            <div className="flex items-center justify-center mb-4">
              <Icon name="Clock" size={24} className="text-primary ml-2" />
              <span className="text-lg font-medium text-foreground">
                متوسط زمان پاسخ: کمتر از ۳۰ ثانیه
              </span>
            </div>
            <p className="text-muted-foreground">
              سیستم هوشمند ما ۲۴ ساعته آماده پاسخگویی به شما است
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorksSection;